import React from "react";
import { observer } from "mobx-react";
import { Sport, TeamStatistics } from "@gp/models";

const DISPLAY_SPORTS = ["soccer"];

export const RedCards = observer(function RedCards(props: {
	sport: Sport;
	statistics?: TeamStatistics;
	className?: string;
}) {
	if (
		!DISPLAY_SPORTS.includes(props.sport.abrv) ||
		props.statistics == undefined
	) {
		return null;
	}

	let redCards = 0;

	if (props.statistics.redCards != undefined) {
		redCards += props.statistics.redCards;
	}
	if (props.statistics.redYellowCards != undefined) {
		redCards += props.statistics.redYellowCards;
	}

	if (redCards === 0) {
		return null;
	}

	return (
		<span className={props.className ? props.className : "match__red-card"}>
			{redCards}
		</span>
	);
});
